module.exports = __webpack_public_path__ + "fonts/HeiseiMinStd-W3.a82aad26.otf";